// src/app/utils/constants.js

/**
 * APP Constants (Single Source of Truth)
 * ----------------------------------------
 * This file centralises all shared configuration values used across the app, especially
 * TanStack Query timings and behaviours.
 *
 * RULE: Hooks must import values from this file instead of defining local stale times
 * (e.g. `const STALE = ...`) or using inline numbers.
 *
 * Why?
 * - Consistent cache behaviour across pages and hooks.
 * - Easy to tune performance globally without chasing scattered numbers.
 * - Reduces copy/paste drift and subtle bugs.
 */

// Time helpers (milliseconds)
export const SECOND = 1000;
export const MINUTE = 60 * SECOND;

/**
 * SAWISA_STALE
 * ------------
 * Stale times define how long cached query data is considered “fresh”.
 *
 * Per your instruction: Use STALE_INTERVAL.DEFAULT for ALL queries.
 */
export const STALE_INTERVAL = {
  DEFAULT: 60 * SECOND,
};

/**
 * SAWISA_QUERY_DEFAULTS
 * ---------------------
 * Default TanStack Query options applied across SAWISA hooks.
 * Hooks should spread this into `useQuery` options.
 */
export const QUERY_DEFAULTS = {
  staleTime: STALE_INTERVAL.DEFAULT,

  // TanStack Query v5: gcTime replaces cacheTime
  gcTime: 30 * MINUTE,

  retry: 1,
  refetchOnWindowFocus: false,
  refetchOnReconnect: true,
  refetchOnMount: false,
};

/**
 * SAWISA_MUTATION_DEFAULTS
 * ------------------------
 * Default options for mutations. We generally avoid retrying writes.
 */
export const MUTATION_DEFAULTS = {
  retry: 0,
};

